// extracted by mini-css-extract-plugin
module.exports = {"share":"Share-module__share___3hzmp","title":"Share-module__title___1mXsq","icons":"Share-module__icons___9JIsW","icon":"Share-module__icon___3B_wu"};